import { TableDTO } from '@services/DTO/TableDTO'

export class POSTableMappingItemDTO {
    constructor(
        public id: string,
        public table: TableDTO,
        public extTableRef: string,
    ) {
    }
}
